export const SUI_NATIVE_TOKEN = '0x2::sui::SUI';
